import React, { useState, useEffect } from 'react';
import './Innovationstory.css';
import { FiCheckCircle } from 'react-icons/fi';

// Assets
import bannerBg from '../../assets/images/main-banner -new.png';
import rightBannerbottom from '../../assets/images/Clinical_Feedback.jpg';
import videoimageone from '../../assets/images/video-one.mp4';
import videoimagetwo from '../../assets/images/video-image-two.jpg';
import videoimagethree from '../../assets/images/video-three.mp4';
import videoimagefour from '../../assets/images/video-four.mp4';
import videoimagefive from '../../assets/images/video-image-five.jpg';
import videoimagesix from '../../assets/images/video-six.mp4';
import teamWork from '../../assets/images/team-work.jpg';
import rightBannerImage from '../../assets/images/right-innovation-banner.png';

import marketstudy from '../../assets/images/market-study.png';
import productstudy from '../../assets/images/product-study.png';
import formexploration from '../../assets/images/form-exploration.png';
import sketching from '../../assets/images/sketching.png';
import foammockup from '../../assets/images/foam-mockup.png';
import threeDmodelling from '../../assets/images/3d-modelling.png';
import internallayout from '../../assets/images/internal-layout.png';
import finaliasingconcept from '../../assets/images/finalising-concept.png';
import finalfoammockup from '../../assets/images/final-mockup.png';
import finalpresentation from '../../assets/images/final-presentation.png';

const stepsData = [
  { label: 'Market Study', image: marketstudy },
  { label: 'Product Study', image: productstudy },
  { label: 'Form Exploration', image: formexploration },
  { label: 'Sketching & Ideation', image: sketching },
  { label: 'Foam Mockups', image: foammockup },
  { label: '3D Modelling', image: threeDmodelling },
  { label: 'Internal Layout', image: internallayout },
  { label: 'Finalising Concepts', image: finaliasingconcept },
  { label: 'Final Foam Mock-ups', image: finalfoammockup },
  { label: 'Final Presentation', image: finalpresentation },
];

export default function InnovationStory() {
  const [popupMedia, setPopupMedia] = useState(null);

  useEffect(() => {
    document.title = "Innovation Story - PulsOjet®";
  }, []);

  return (
    <div className="innovation-wrapper-story">
      {/* Banner */}
      <div className="banner-wrpper-max" style={{ backgroundImage: `url(${bannerBg})` }}>
        <section className="banner">
          <div className="banner-overlay">
            <div className="banner-content">
              <div className="banner-text">
                <h1>Our Innovation Story</h1>
                <p>
                  Innovation born out of necessity, not imitation. In a market dominated by imports and bottlenecks,
                  we built PulsOjet® from the ground up — to solve real surgical challenges with real Indian ingenuity.
                </p>
              </div>
            </div>
            <div className="banner-sidebar">
              <img src={rightBannerImage} alt="Right Banner Device" />
            </div>
          </div>
        </section>
      </div>

      {/* Development Journey */}
      <section className="innovation-development-section">
        <h2 className="innovation-section-title">Development Journey</h2>
        <div className="innovation-development-grid">
          {stepsData.map((step, i) => (
            <div key={i} className="innovation-step-block">
              <div className="innovation-step-item">
                <div className="innovation-step-number">{i + 1}</div>
                <div className="innovation-step-label">{step.label}</div>
              </div>
              <div className="innovation-placeholder-box">
                <img src={step.image} alt={step.label} className="innovation-step-image" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testing */}
      <section className="innovation-testing-section">
        <h2 className="innovation-section-title">Testing & Clinical Validation</h2>
        <div className="innovation-testing-grid">
          <ul className="innovation-testing-list">
            {[
              "Bench testing for pressure, flow rate, and suction consistency",
              "Usability testing in simulated OR environment",
              "Feedback collected from 12+ orthopedic surgeons across 3 cities",
              "Iterative design changes based on surgeon input",
              "Clinical validation during knee and trauma surgery simulations"
            ].map((text, i) => (
              <li key={i}>
                <FiCheckCircle className="check-icon" />
                <em>{text}</em>
              </li>
            ))}
          </ul>
          <div className="innovation-placeholder-box">
            <img src={rightBannerbottom} alt="Clinical Feedback" className="clinical-feedback" />
          </div>
        </div>

        {/* Visual Glimpse */}
        <h2 className="innovation-section-title">Visual Glimpse: From Bench to OR</h2>
        <div className="innovation-media-gallery">
          <div className="innovation-gallery-grid">
            {[ 
              { type: 'video', src: videoimageone },
              { type: 'image', src: videoimagetwo },
              { type: 'video', src: videoimagethree },
              { type: 'video', src: videoimagefour },
              { type: 'image', src: videoimagefive },
              { type: 'video', src: videoimagesix }
            ].map((media, idx) => (
              <div key={idx} onClick={() => setPopupMedia(media)}>
                {media.type === 'video' ? (
                  <video src={media.src} autoPlay muted loop playsInline className="innovation-video-thumb" />
                ) : (
                  <img src={media.src} alt={`Glimpse ${idx + 1}`} className="innovation-image-thumb" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="innovation-team-section">
        <div className="innovation-team-content">
          <h2 className="innovation-section-title">Built by a Team that Cares</h2>
          <p>
            Our in-house engineering and product design team led the core innovation — not just from behind a desk,
            but hands-on in labs, OR simulations, and field trials. Every element was shaped by purpose, not shortcuts.
          </p>
          <div className="innovation-placeholder-box">
            <img src={teamWork} alt="Teamwork" className="Teamwork" />
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {popupMedia && (
        <div className="innovation-popup-overlay" onClick={() => setPopupMedia(null)}>
          <div className="innovation-popup-content" onClick={(e) => e.stopPropagation()}>
            {popupMedia.type === 'video' ? (
              <video src={popupMedia.src} controls autoPlay className="innovation-popup-media" />
            ) : (
              <img src={popupMedia.src} alt="Popup View" className="innovation-popup-media" />
            )}
            <button className="popup-close-btn" onClick={() => setPopupMedia(null)}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
}
